import { Descriptions, Divider, Space, Typography } from 'antd';
import moment from 'moment';
import { BsBox2 } from 'react-icons/bs';

import SectionCard from '../../../components/sectionCard/SectionCard';
import { formatCurrency } from '../../../utils/format';
import useAddExpressDeliveryStore from '../Add/store';

const { Text } = Typography;

/** Descriptions-ийн ерөнхий тохиргоо: label дээр, value доор, зай багатай */
const descriptionProps = {
  size: 'small',
  colon: false,
  layout: 'vertical',
  column: { xs: 1, sm: 2 },
  labelStyle: { paddingBottom: 0 },
  contentStyle: { paddingBottom: 8 },
};

/** Хоосон утгыг "-" болгож харуулна */
const val = (value) => (value === null || value === undefined || value === '' ? '-' : value);

const OrderPreview = ({ order, index }) => {
  const { products, step1Values } = useAddExpressDeliveryStore() ?? {};
  const deliveryTime = step1Values?.deliveryTime;
  const {
    size,
    firstName,
    phoneNumber,
    mail,
    deliveryType,
    deliveryDetail = '',
    orderDescription,
    dropoffDate,
    priceDetail,
  } = order ?? {};

  const { title } = (products || []).find((el) => el?.attributes?.size === size) ?? {};

  const deliveryTypeContext = () => {
    if (deliveryType === 'deliverytocabinet') {
      return 'PPBox-руу хүргэх';
    }
    if (deliveryType === 'deliveryHub') {
      return 'Hub-д хүргэх';
    }
    if (deliveryType === 'delivery') {
      return 'Гарт хүргэлт энгийн';
    }
  };

  const priceItems =
    deliveryTime === 'express'
      ? [
          {
            key: 'express',
            label: 'Шуурхай хүргэлтийн төлбөр',
            children: formatCurrency(priceDetail?.expressAmount?.totalPrice || 0),
          },
          {
            key: 'exceeded',
            label: '2км -ээс хэтэрсэн нэмэлт төлбөр',
            children: formatCurrency(priceDetail?.expressAmount?.eachLengthKmPrice || 0),
          },
          {
            key: 'total',
            label: 'Нийт төлбөр',
            children: <Text strong>{formatCurrency(priceDetail?.totalAmount || 0)}</Text>,
          },
        ]
      : [
          {
            key: 'execution',
            label: 'Захиалга гүйцэтгэлийн төлбөр',
            children: formatCurrency(priceDetail?.executionAmount?.totalPrice || 0),
          },
          {
            key: 'delivery',
            label: 'Хүргэлтийн төлбөр',
            children: formatCurrency(priceDetail?.deliveryAmount?.totalPrice || 0),
          },
          {
            key: 'total',
            label: 'Нийт төлбөр',
            children: <Text strong>{formatCurrency(priceDetail?.totalAmount || 0)}</Text>,
          },
        ];

  /** Захиалга тус бүрийн төлбөр серверээс ирсэн үед л харуулна */
  const hasPriceDetail = Object.keys(priceDetail ?? {}).length > 0;

  return (
    <SectionCard icon={<BsBox2 />} title={`Захиалга №${index + 1}`}>
      <Space direction="vertical" size={0} style={{ width: '100%' }}>
        {hasPriceDetail && (
          <>
            <Descriptions
              {...descriptionProps}
              column={{ xs: 1, sm: 2, lg: priceItems.length }}
              items={priceItems}
            />
            <Divider style={{ marginBlock: '4px 16px' }} />
          </>
        )}

        <Descriptions
          {...descriptionProps}
          column={{ xs: 1, sm: 2, lg: 4 }}
          items={[
            { key: 'name', label: 'Хэрэглэгчийн нэр', children: val(firstName) },
            { key: 'phone', label: 'Хэрэглэгчийн утас', children: val(phoneNumber) },
            { key: 'mail', label: 'Хэрэглэгчийн мэйл', children: val(mail) },
            { key: 'size', label: 'Хэмжээ', children: val(title) },
          ]}
        />

        <Descriptions
          {...descriptionProps}
          column={{ xs: 1, sm: 2, lg: 4 }}
          items={[
            {
              key: 'deliveryType',
              label: 'Хүргэлтийн төрөл',
              children: val(deliveryTypeContext()),
            },
            {
              key: 'address',
              label: deliveryType === 'delivery' ? 'Дэлгэрэнгүй хаяг' : 'PP box',
              children: <div style={{ overflowWrap: 'break-word' }}>{val(deliveryDetail)}</div>,
            },
            {
              key: 'dropoffDate',
              label: 'Авах огноо',
              children: dropoffDate ? moment(dropoffDate).format('YYYY/MM/DD') : '-',
            },
            {
              key: 'description',
              label: 'Нэмэлт',
              children: <div style={{ overflowWrap: 'break-word' }}>{val(orderDescription)}</div>,
            },
          ]}
        />
      </Space>
    </SectionCard>
  );
};

export default OrderPreview;
